import axios from "axios";

export const getBrandAgreement = async (brandUserId, email) => {
    return axios
        .get(`admin/user/${brandUserId}/brand-agreement`, {
            params: { email },
        })
        .then((response) => response.data)
        .catch((error) => {
            console.error("Failed to look up brand agreement");
            console.error(error);
            return {
                success: false,
                message: error?.response?.data?.message || "Request failed.",
            };
        });
};

export const resetBrandAgreement = async (brandUserId, accountId, reason) => {
    return axios
        .delete(`admin/user/${brandUserId}/brand-agreement/${accountId}`, {
            data: { reason },
        })
        .then((response) => response.data)
        .catch((error) => {
            console.error("Failed to reset brand agreement");
            console.error(error);
            return {
                success: false,
                message: error?.response?.data?.message || "Request failed.",
            };
        });
};
